export default __webpack_public_path__ + "static/media/kk.f3fb3565.jpg";